document.addEventListener('DOMContentLoaded', function () {
  
  const shopTimeZone = 'Europe/Berlin';

  // Utility: Parse close datetime from Liquid (assumed to be in shop timezone)
  function parseCloseDateTime(dateTimeString) {
    if (!dateTimeString) return null;
    
    try {
      // The datetime from Liquid is in format: 2024-01-01T15:30:00
      // We need to treat this as Europe/Berlin time and convert to UTC for accurate comparison
      
      // Parse the components
      const [datePart, timePart] = dateTimeString.split('T');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hours, minutes, seconds = 0] = timePart.split(':').map(Number);
      
      // Create a date representing this time in the local browser timezone first
      const localDate = new Date(year, month - 1, day, hours, minutes, seconds);
      
      // Now we need to find what this time would be in UTC if it were in Berlin timezone
      // Use the most reliable cross-browser method
      
      // Create two dates: one interpreted as local time, one as UTC
      const localString = localDate.toISOString().slice(0, 19); // "2024-01-01T15:30:00"
      const utcDate = new Date(localString + 'Z'); // Treat as UTC
      
      // Get the current timezone offset for Berlin
      const now = new Date();
      const berlinTime = new Date(now.toLocaleString("en-US", {timeZone: shopTimeZone}));
      const localTime = new Date(now.toLocaleString("en-US"));
      const berlinOffset = (berlinTime.getTime() - localTime.getTime()) / (1000 * 60); // in minutes
      
      // Adjust the UTC date by the Berlin offset to get the correct UTC time
      const correctedUtcTime = utcDate.getTime() - (berlinOffset * 60 * 1000);
      
      return new Date(correctedUtcTime);
      
    } catch (error) {
      console.warn('Error parsing close datetime:', dateTimeString, error);
      
      // Fallback: try simple parsing
      try {
        const fallbackDate = new Date(dateTimeString);
        if (!isNaN(fallbackDate.getTime())) {
          return fallbackDate;
        }
      } catch (e) {
        // Ignore fallback errors
      }
      
      return null;
    }
  }

  // Utility: Create countdown string including days (conditionally) and German translation
  function getCountdownString(targetDate) {
    if (!targetDate) return null;
    
    // Get current time in UTC
    const now = new Date();
    
    // Calculate the difference
    const diff = Math.max(targetDate.getTime() - now.getTime(), 0);
    
    if (diff === 0) return null; // Countdown finished
    
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
    // Translate labels to German
    const daysLabel = days === 1 ? "Tag" : "Tage";
    const hoursLabel = hours === 1 ? "Stunde" : "Stunden";
    const minutesLabel = minutes === 1 ? "Minute" : "Minuten";
    const secondsLabel = seconds === 1 ? "Sekunde" : "Sekunden";
  
    // Construct the countdown string
    let countdown = "";
    if (days > 0) {
      countdown += `${days} ${daysLabel} `;
    }
    countdown += `${hours} ${hoursLabel} ${minutes} ${minutesLabel} ${seconds} ${secondsLabel}`;
  
    return countdown;
  }

  // Function to update collection countdowns
  function updateCollectionCountdowns() {
    const countdownElements = document.querySelectorAll('[data-collection-countdown]');
    
    countdownElements.forEach(element => {
      const closeDatetime = element.getAttribute('data-close-datetime');
      const countdownType = element.getAttribute('data-countdown-type') || 'closing';
      
      if (!closeDatetime) return;
      
      const closeDate = parseCloseDateTime(closeDatetime);
      if (!closeDate) {
        element.textContent = "Ungültiges Datum";
        return;
      }
      
      const countdown = getCountdownString(closeDate);
      
      if (countdown) {
        if (countdownType === 'opening') {
          element.textContent = `Der Shop öffnet in ${countdown}`;
        } else {
          element.textContent = `Der Verkauf schließt in ${countdown}`;
        }
      } else {
        // Countdown finished, refresh page to show new state
        if (countdownType === 'opening') {
          element.textContent = "Der Shop ist jetzt geöffnet!";
        } else {
          element.textContent = "Der Verkauf wurde geschlossen";
        }
        setTimeout(() => {
          window.location.reload();
        }, 2000); // Give user 2 seconds to see the message before refresh
      }
    });
  }

  // Start countdown updates if there are countdown elements
  if (document.querySelector('[data-collection-countdown]')) {
    updateCollectionCountdowns();
    setInterval(updateCollectionCountdowns, 1000);
  }
});
